import React from 'react';
export const AccordionControls = ({ title, controls }) => !(title || controls) ? null : (React.createElement("div", { className: "cb-accordion-controls" },
    title && (React.createElement("div", { className: "cb-accordion-title" },
        React.createElement("h3", null, title))),
    controls && (React.createElement("div", { className: "cb-accordion-buttons" },
        React.createElement("button", { type: "button", className: "cb-btn cb-btn-naked cb-accordion-expand" }, "Expand All"),
        React.createElement("button", { type: "button", className: "cb-btn cb-btn-naked cb-accordion-collapse" }, "Collapse All")))));
//# sourceMappingURL=AccordionControls.js.map